module.exports = __webpack_public_path__ + "img/defaultAvatar.06b07b6b.png";